import { useContext, useEffect, useState } from "react";
import { getOptionsSelectedText } from "src/utils/Functions";
import InputFilterBox from "../InputFilterBox/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { propertyTypes } from "../options";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";
import { propertiesTypeInTemporal } from "@Utils/Functions";

export const PropertyTypeFilter = ({show}) => {
    if (!show) return null;

    const { filters, filtersTags } = useFilters();
    const { country_code } = useContext(ConfigStateContext);
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const [propertyTypeText, setPropertyTypeText] = useState('Tipo de Propiedad');
    const [propertiesTypeList, setPropertiesTypeList] = useState([]);
    const [propertiesTypeByCountry, setPropertiesTypeByCountry] = useState([]);

    useEffect(() => {
      if (country_code) setPropertiesTypeByCountry(propertyTypes.filter(type => type.countries.includes(country_code ? country_code.toUpperCase() : "")))
    }, [country_code])

    useEffect(() => {
        if (filters?.operation_type_id && country_code) {
            const filteredByProjects = filters.projects ? propertiesTypeByCountry.filter(item => item.projects === !!filters.projects) : propertiesTypeByCountry;
            const list = filteredByProjects.map((type) => ({ text: type.text, value: type.value }));
            const listFiltered = list.filter(item => propertiesTypeInTemporal(Number(item.value)));
            const isTemporal = filters?.operation_type_id === 4;

            setPropertiesTypeList(isTemporal ? listFiltered : list);
        }
    }, [filters?.operation_type_id, filters.projects, propertiesTypeByCountry]);

    useEffect(() => {
        if (filters.property_type_id) {
            let text = getOptionsSelectedText(propertiesTypeList, filters?.property_type_id)
            text = text !== "" ? text : 'Tipo de Propiedad';

            setPropertyTypeText(text)
        } else {
            setPropertyTypeText('Tipo de Propiedad')
        }
    }, [filters.property_type_id])

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentPropertiesTypeFilter = filters.property_type_id ?? []
        const { value, checked } = e?.target
        const parsedValue = Number(value);
        let updatedPropertiesTypeFilter = [];

        if (parsedValue === -1) {
            changeFilters({ property_type_id: [] });
        } else {
            if (checked) {
                updatedPropertiesTypeFilter = [...currentPropertiesTypeFilter, parsedValue];
            } else {
                updatedPropertiesTypeFilter = currentPropertiesTypeFilter.filter(b => b !== parsedValue);
            }

            const newPropertiesTypeFilter = propertiesTypeList.filter(item => updatedPropertiesTypeFilter.includes(item.value));
            const newPropertiesTypeValues = newPropertiesTypeFilter.map((type) => type.value);
            const showSurfaceRange = [3, 12].some(e => newPropertiesTypeValues.includes(e))

            changeFilters({
                property_type_id: newPropertiesTypeFilter,
                m2Min: showSurfaceRange ? filtersTags?.m2Min : null,
                m2Max: showSurfaceRange ? filtersTags?.m2Max : null,
                m2Type: showSurfaceRange ? filtersTags?.m2Type : null
            });
        }
    }

    const handleCleanFilter = () => {
        const valuesToReset = {
            property_type_id: []
        }

        changeFilters(valuesToReset)
    }

    if (!propertiesTypeList.length) return null;

    return (
        <InputFilterBox
            active={!!filters?.property_type_id?.length}
            label={propertyTypeText}
            onCancelFilter={ !!filters?.property_type_id?.length ? handleCleanFilter : undefined}
            scrollable
        >
            <div className="optionList">
                {propertiesTypeList?.map((val, i) => {
                    return (
                        <div key={val.text + "-" + i} className="optionList__option">
                            <input
                                type="checkbox"
                                className="checkBoxCustomInput"
                                onChange={handleOnChange}
                                name={"propertyTypeId"}
                                id={val.text}
                                value={val.value}
                                checked={
                                    ((typeof filters?.property_type_id === "undefined" || !filters?.property_type_id.length) && val?.value === -1) ||
                                    typeof filters?.property_type_id !== "undefined" && filters?.property_type_id.includes(val?.value)
                                }
                            />
                            <label htmlFor={val.text}>{val.text}</label>
                        </div>
                    );
                })}
            </div>
        </InputFilterBox>
    )
}
